<p-confirmDialog key="add" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="MinWidth">
	<!--Info Grid-->
	<div class="MainGrid">
		<!--Left Col (All)-->
		<div class="ColGrid">
			<label>Event Code:</label>
			<input [disabled]="loading == true || Saving == true" class="form-control" type="text" [(ngModel)]="EventDescShort" />

			<div>
				<label>Event Name:</label>
				<p style="font-size: 11px; color: orangered; font-weight: bold">* Displayed in ScanStation</p>
			</div>
			<textarea [disabled]="loading == true || Saving == true" class="TextArea" rows="5" [(ngModel)]="EventDescLong"></textarea>

			<label>Location:</label>
			<input [disabled]="loading == true || Saving == true" class="form-control" type="text" [(ngModel)]="EventLocation" />

			<label *ngIf="RecurranceTypeID == 0">Event Date:</label>
			<p-calendar
				*ngIf="RecurranceTypeID == 0"
				[disabled]="loading == true || Saving == true"
				showIcon="true"
				showButtonBar="true"
				[(ngModel)]="EventDT"
				name="EventDate"
			></p-calendar>

			<label for="SpecifyGateOpenTime">Specify Gate Open Time:</label>
			<input [disabled]="loading == true || Saving == true" type="checkbox" class="CHK" name="SpecifyGateOpenTime" [(ngModel)]="SpecifyGateOpenTime" />

			<label>Gates Open Time:</label>
			<p-calendar
				[disabled]="loading == true || Saving == true || !SpecifyGateOpenTime"
				timeOnly="true"
				[(ngModel)]="GatesOpenTime"
				hourFormat="12"
				name="GatesOpenTime"
			></p-calendar>

			<label>Start Time:</label>
			<p-calendar [disabled]="loading == true || Saving == true" timeOnly="true" [(ngModel)]="StartTime" hourFormat="12" name="StartTime"></p-calendar>

			<label>End Time:</label>
			<p-calendar [disabled]="loading == true || Saving == true" timeOnly="true" [(ngModel)]="EndTime" hourFormat="12" name="EndTime"></p-calendar>

			<label for="ValidationCheckOnly">Validation Check Only:</label>
			<input [disabled]="loading == true || Saving == true" type="checkbox" class="CHK" name="ValidationCheckOnly" [(ngModel)]="ValidationCheckOnly" />

			<label>Scheduled:</label>
			<select
				[disabled]="loading == true || ChangeSchedule == false || Saving == true"
				class="form-control"
				name="RecurranceTypeID"
				[(ngModel)]="RecurranceTypeID"
			>
				<option *ngFor="let r of lstRecurranceType" [ngValue]="r.ID">
					{{ r.Desc }}
				</option>
			</select>
		</div>

		<!--Right Col (Only Recurring)-->
		<div *ngIf="RecurranceTypeID > 0" class="RighCol">
			<!--Weekly-->
			<div *ngIf="RecurranceTypeID == 1" class="RightBorder">
				<h3>Weekly Recurrence</h3>

				<div class="RightSubGrid">
					<label>Recur every:</label>
					<div class="RecurDiv">
						<input [disabled]="loading == true || Saving == true" class="form-control" type="number" [(ngModel)]="WeekRecurCount" min="1" />
						<label>week(s)</label>
					</div>

					<label>On:</label>
					<div class="WeekGrid">
						<input id="WeekDayMonInd" name="WeekDayMonInd" class="CHK" type="checkbox" [(ngModel)]="WeekDayMonInd" />
						<label [disabled]="loading == true || Saving == true" for="WeekDayMonInd">Monday</label>

						<input id="WeekDayTueInd" name="WeekDayTueInd" class="CHK" type="checkbox" [(ngModel)]="WeekDayTueInd" />
						<label [disabled]="loading == true || Saving == true" for="WeekDayTueInd">Tuesday</label>

						<input
							[disabled]="loading == true || Saving == true"
							id="WeekDayWedInd"
							name="WeekDayWedInd"
							class="CHK"
							type="checkbox"
							[(ngModel)]="WeekDayWedInd"
						/>
						<label for="WeekDayWedInd">Wednesday</label>

						<input
							[disabled]="loading == true || Saving == true"
							id="WeekDayThuInd"
							name="WeekDayThuInd"
							class="CHK"
							type="checkbox"
							[(ngModel)]="WeekDayThuInd"
						/>
						<label for="WeekDayThuInd">Thursday</label>

						<input
							[disabled]="loading == true || Saving == true"
							id="WeekDayFriInd"
							name="WeekDayFriInd"
							class="CHK"
							type="checkbox"
							[(ngModel)]="WeekDayFriInd"
						/>
						<label for="WeekDayFriInd">Friday</label>

						<input
							[disabled]="loading == true || Saving == true"
							id="WeekDaySatInd"
							name="WeekDaySatInd"
							class="CHK"
							type="checkbox"
							[(ngModel)]="WeekDaySatInd"
						/>
						<label for="WeekDaySatInd">Saturday</label>

						<input
							[disabled]="loading == true || Saving == true"
							id="WeekDaySunInd"
							name="WeekDaySunInd"
							class="CHK"
							type="checkbox"
							[(ngModel)]="WeekDaySunInd"
						/>
						<label for="WeekDaySunInd">Sunday</label>
					</div>
				</div>
			</div>

			<!--Monthly-->
			<div *ngIf="RecurranceTypeID == 2" class="RightBorder">
				<h3>Monthly Recurrence</h3>

				<div class="MonthOpt1">
					<input
						[disabled]="loading == true || Saving == true"
						[value]="1"
						id="MonthOpt1"
						name="RecurrancePatternTypeID"
						[(ngModel)]="RecurrancePatternTypeID"
						type="radio"
					/>
					<label for="MonthOpt1">Day</label>
					<input [disabled]="loading == true || Saving == true" class="form-control" type="number" min="1" [(ngModel)]="MonthEveryDOM" />
					<label for="MonthOpt1">of every</label>
					<input [disabled]="loading == true || Saving == true" class="form-control" type="number" min="1" [(ngModel)]="MonthEveryRecurCount" />
					<label for="MonthOpt1">month(s)</label>
				</div>

				<div class="MonthOpt2">
					<input
						[disabled]="loading == true || Saving == true"
						[value]="2"
						id="MonthOpt2"
						name="RecurrancePatternTypeID"
						[(ngModel)]="RecurrancePatternTypeID"
						type="radio"
					/>
					<label for="MonthOpt2">The</label>
					<select [disabled]="loading == true || Saving == true" class="form-control" [(ngModel)]="MonthOnWeekNbr">
						<option *ngFor="let r of lstWeekNbr" [ngValue]="r.ID">
							{{ r.Desc }}
						</option>
					</select>
					<select [disabled]="loading == true || Saving == true" class="form-control" [(ngModel)]="MonthOnDOW">
						<option *ngFor="let r of lstDay" [ngValue]="r.ID">
							{{ r.Desc }}
						</option>
					</select>
					<label for="MonthOpt2">of every</label>
					<input [disabled]="loading == true || Saving == true" class="form-control" type="number" min="1" [(ngModel)]="MonthOnRecurCount" />
					<label for="MonthOpt2">month(s)</label>
				</div>
			</div>

			<!--Yearly-->
			<div *ngIf="RecurranceTypeID == 3" class="RightBorder">
				<h3>Yearly Recurrence</h3>

				<div class="YearOpt1">
					<input
						[disabled]="loading == true || Saving == true"
						[value]="1"
						id="YearOpt1"
						name="RecurrancePatternTypeID"
						[(ngModel)]="RecurrancePatternTypeID"
						type="radio"
					/>
					<label for="YearOpt1">Every</label>
					<select [disabled]="loading == true || Saving == true" class="form-control" [(ngModel)]="YearEveryMOY">
						<option *ngFor="let r of lstMonth" [ngValue]="r.ID">
							{{ r.Desc }}
						</option>
					</select>
					<input [disabled]="loading == true || Saving == true" class="form-control" type="number" [(ngModel)]="YearEveryDOM" />
				</div>

				<div class="YearOpt2">
					<input
						[disabled]="loading == true || Saving == true"
						[value]="2"
						id="YearOpt2"
						name="RecurrancePatternTypeID"
						[(ngModel)]="RecurrancePatternTypeID"
						type="radio"
					/>
					<label for="YearOpt2">The</label>
					<select [disabled]="loading == true || Saving == true" class="form-control" [(ngModel)]="YearOnWeekNbr">
						<option *ngFor="let r of lstWeekNbr" [ngValue]="r.ID">
							{{ r.Desc }}
						</option>
					</select>
					<select [disabled]="loading == true || Saving == true" class="form-control" [(ngModel)]="YearOnDOW">
						<option *ngFor="let r of lstDay" [ngValue]="r.ID">
							{{ r.Desc }}
						</option>
					</select>
					<label for="YearOpt2">of</label>
					<select [disabled]="loading == true || Saving == true" class="form-control" [(ngModel)]="YearOnMonth">
						<option *ngFor="let r of lstMonth" [ngValue]="r.ID">
							{{ r.Desc }}
						</option>
					</select>
				</div>
			</div>

			<!--Range (All)-->
			<div *ngIf="RecurranceTypeID > 0" class="RightBorder">
				<h3 class="FullWidth">Range of Recurrence</h3>

				<div class="StartGrid">
					<label>Start Date:</label>
					<p-calendar
						[disabled]="loading == true || Saving == true"
						showIcon="true"
						showButtonBar="true"
						[(ngModel)]="RangeStartDate"
						name="RangeStartDate"
					></p-calendar>
				</div>

				<div class="NoEndDiv">
					<input
						[disabled]="loading == true || Saving == true"
						id="NoEndDate"
						name="RecurranceRangeTypeID"
						[value]="1"
						[(ngModel)]="RecurranceRangeTypeID"
						type="radio"
					/>
					<label for="NoEndDate">No End Date</label>
				</div>

				<div class="EndOccurDiv">
					<input
						[disabled]="loading == true || Saving == true"
						id="EndAfter"
						name="RecurranceRangeTypeID"
						[value]="2"
						[(ngModel)]="RecurranceRangeTypeID"
						type="radio"
					/>
					<label for="EndAfter">End After:</label>
					<input [disabled]="loading == true || Saving == true" class="form-control" type="number" [(ngModel)]="RangeEndOccurancesTotal" min="1" />
					<label for="EndAfter">occurrences</label>
				</div>

				<div class="EndByDiv">
					<input
						[disabled]="loading == true || Saving == true"
						id="EndBy"
						name="RecurranceRangeTypeID"
						[value]="3"
						[(ngModel)]="RecurranceRangeTypeID"
						type="radio"
					/>
					<label for="EndBy">End By:</label>
					<p-calendar [disabled]="Saving == true" showIcon="true" showButtonBar="true" [(ngModel)]="RangeEndDate" name="RangeEndDate"></p-calendar>
				</div>
			</div>
		</div>
	</div>
</div>

<!--Buttons-->
<div class="Buttons" [style.marginBottom]="RecurranceTypeID > 0 ? '200px' : '0px'">
	<button [disabled]="loading == true || Saving == true" class="btn btn-primary" (click)="onAdd()">Update</button>
	<button [disabled]="Saving == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
